import api from '../api';
const jsRoutes = require('routes.js.erb');

const getItemComments = function({ commit }, itemId) {
  return api.get(jsRoutes.api_v5_comments_path({ commentable_type: 'Item', commentable_id: itemId })).then(function(response){
    commit('setComments', response.data.data.comments);
  });
};


const destroy = function({ commit, state }, commentId) {
  api.delete(`${jsRoutes.api_v5_comments_path()}/${commentId}`).then(function(response){
    const deletedComment = response.data.data.comment;
    const comments = { ...state }.comments;

    commit('setComments', comments.filter(comment => comment.id != deletedComment.id))
  })
};

const create = function({ commit, state }, params) {
  api.post(jsRoutes.api_v5_comments_url(), params)
  .then(function(response) {
    const comment = response.data.data.comment;
    const comments = { ...state }.comments
    comments.push(comment);

    commit('setComments', comments);
  })
  .catch(function(err){
    alert(`Comment could not be added: ${err}`);
  })
};

const update = function({ commit, state }, params) {
  api.put(`${jsRoutes.api_v5_comments_path()}/${params.commentId}`, params.params)
  .then(function(response) {
    const comment = response.data.data.comment;
    let comments = { ...state }.comments

    comments = comments.map(c => (c.id === comment.id) ? comment : c)

    commit('setComments', comments);
  })
  .catch(function(err){
    alert(`Comment could not be added: ${err}`);
  })
};

let openLoginModal = function() {
  setModalUTM(viewerUtmParams("comments", gon.item.id));
  $("#login-modal").show();
};

let openSignupModal = function() {
  setModalUTM(viewerUtmParams("comments", gon.item.id));
  $("#signup-modal").show();
};

export { getItemComments, destroy, create, update, openLoginModal, openSignupModal };